<template>
  <div>
    <v-card flat>
      <v-card-title>
        <h6 class="mb-0">Groupes de {{ animateur.displayName }}</h6>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-card-text>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Rechercher groupe"
              single-line
              hide-details
            ></v-text-field>
            <v-data-table
              dense
              :loading="loadingTable"
              :headers="headers"
              :items="groupes"
              :search="search"
              item-key="id"
              locale="fr"
              :item-class="row_classes"
            >
              <template v-slot:item.projets="{ item }">
                <div v-if="item.projets">
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    x-small
                    color="red"
                    v-if="item.projets.length === 0"
                  >
                    <v-icon>
                      mdi-alert-circle-outline
                    </v-icon>
                  </v-btn>

                  <ul v-else :class="redPink(item.projets)">
                    <li
                      v-for="(projets, indexprojets) in item.projets"
                      :key="indexprojets"
                    >
                      {{ projets.ll_programme }} -
                      {{ projets.abbr_bailleur }}
                    </li>
                  </ul>
                </div>
              </template>

              <template v-slot:item.actions2="{ item }">
                <div class="row mx-1">
                  <div class="col mx-0 px-0 py-1" v-if="item.projets">
                    <v-tooltip
                      bottom
                      v-for="(projet, indexprojets) in item.projets"
                      :key="indexprojets"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          rounded
                          small
                          dark
                          class="success mr-2"
                          @click="detailsGroupe(item, projet)"
                        >
                          Projet {{ projet.ll_programme }}
                          <v-icon>chevron_right</v-icon>
                        </v-btn>
                      </template>
                      <span>Détails du groupe</span>
                    </v-tooltip>

                    <!--       <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          x-small
                          fab
                          dark
                          class="success mr-2"
                          @click="detailsGroupe(item)"
                        >
                          <v-icon>chevron_right</v-icon>
                        </v-btn>
                      </template>
                      <span>Acéder aux détails du groupe</span>
                    </v-tooltip>
 -->
                  </div>
                </div>
              </template>

              <template v-slot:item.actions="{ item }">
                <div class="row mx-1">
                  <div
                    class="col mx-0 px-0 py-1"
                    v-if="item.menageGenerated"
                  ></div>
                  <div v-else>
                    <dialogGenerateMenages
                      :groupe="item"
                      @menageGenerated="GetGroupesDeAnimateur()"
                    />
                  </div>

                  <div
                    class="col mx-0 px-0 py-1"
                    v-if="animateur.id != item.responsable"
                  >
                    <v-btn outlined x-small fab dark class="red mr-2">
                      <v-icon>mdi-alert-circle-outline</v-icon>
                    </v-btn>
                  </div>

                  <div class="col mx-0 px-0 py-1">
                    <buttonCheckProjetAnimateur
                      :key="item.id"
                      :groupe="item"
                      :animateur="animateur"
                    />
                  </div>
                  <div class="col mx-0 px-0 py-1">
                    <v-tooltip bottom v-if="user.role != 'operateur'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          x-small
                          fab
                          dark
                          class="blue"
                          v-on="on"
                          @click="printFicheFormation(item)"
                        >
                          <v-icon>mdi-printer</v-icon>
                        </v-btn>
                      </template>
                      <span>Imprimer fiche de formation</span>
                    </v-tooltip>
                  </div>
                  <div class="col mx-0 px-0 py-1">
                    <v-tooltip bottom v-if="user.role != 'operateur'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          x-small
                          fab
                          dark
                          class="info"
                          v-on="on"
                          @click="printFicheDotation(item)"
                        >
                          <v-icon>mdi-printer-settings</v-icon>
                        </v-btn>
                      </template>
                      <span>Imprimer fiche de distribution</span>
                    </v-tooltip>
                  </div>

                  <!-- <div class="col mx-0 px-0 py-1">
                    <DialogLinkGroupAndProjets v-if="user.role!='operateur'"
                      :groupe="item"
                      @reloadAfficher="GetGroupesDeAnimateur()"
                    />
                  </div>
                  <div class="col mx-0 px-0 py-1">
                    <v-tooltip bottom v-if="user.role!='operateur'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          x-small
                          fab
                          dark
                          class="danger"
                          @click="deleteGroup(item)"
                        >
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Supprimer le groupe</span>
                    </v-tooltip>
                  </div> -->
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    buttonCheckProjetAnimateur: require("@/components/groupes/buttonCheckProjetAnimateur.vue")
      .default,

    DialogLinkGroupAndProjets: require("@/components/DialogLinkGroupAndProjets.vue")
      .default,
    DialogAssignGroupToUser: require("@/components/superviseur/DialogAssignGroupToUser.vue")
      .default,
    groupeDialog: require("@/components/groupes/groupeDialog.vue").default,
    dialogGenerateMenages: require("@/components/groupes/dialogGenerateMenages.vue")
      .default,
  },
  created() {
    this.GetGroupesDeAnimateur();
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      MembresDuGroupeActifs: (state) =>
        _.filter(state.Membres.MembresDuGroupe, { actif_dans_groupe: 1 }),
    }),
  },
  data() {
    return {
      groupes: [],
      loadingTable: false,
      loading: false,
      search: "",
      headers: [
        { text: "", value: "actions" },
        { text: "", value: "actions2" },

        {
          text: "Groupe",
          label: "Groupe",
          value: "nom_groupe",
          field: "nom_groupe",
        },
        /*  {
          text: "projectList",
          value: "projectList",
          label: "projectList",
          field: "projectList",
          dataFormat: this.projetFormat,
        }, */
        {
          text: "Projets",
          value: "projets",
          label: "Projets",
          field: "projets",
          dataFormat: this.projetFormat,
        },
        /*  {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        }, */
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
        {
          text: "Date de création",
          value: "date_insert_gp",
          label: "Date de création",
          field: "date_insert_gp",
          dataFormat: this.dateFormat,
        },
        {
          text: "Date de mise à jour",
          value: "date_updated",
          label: "Date de mise à jour",
          field: "date_updated",
          dataFormat: this.dateFormat,
        },

        {
          text: "Utilisateur",
          value: "modifier_user_name",
          label: "Utilisateur",
          field: "modifier_user_name",
        },
      ],
    };
  },
  props: {
    animateur: {
      required: true,
    },
  },
  methods: {
    ...mapActions({
      deleteGroupeStore: "Groupes/deleteGroupe",
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      SetItemById: "Groupes/SetItemById",
    }),
    row_classes(item) {
      if (item.menageGenerated) {
        return "ok";
      } else {
        return "pink lighten-5";
      }
    },
    deleteGroup(item) {
      let self = this;
      this.$confirm(
        "Voulez vous vraiment supprimer le  groupe <strong>" +
          item.nom_groupe +
          "</strong> ?, ses membres et ses différentes activités?"
      ).then((res) => {
        if (res) {
          self.deleteGroupeStore(item).then(() => {
            self.GetGroupesDeAnimateur();
          });
        }
      });
    },
    projetFormat(value) {
      var tab = [];
      value.forEach((item, index) => {
        tab[index] = item.ll_programme;
      });

      return `${tab.toString()}`;
    },
    dateFormat(value) {
      return $moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
    redPink(projets) {
      if (projets.length === 0) {
        return "redPink";
      }
    },
    detailsGroupe(item, projet) {
      this.$router.push({
        path: `/detailsGroupe/${item.id}`,
        query: { projet: projet.id },
      });
    },
    GetGroupesDeAnimateur() {
      let self = this;
      this.loading = true;
      this.loadingTable = true;

      self.groupes = [];
      this.$firebase
        .firestore()
        .collection("groupes")
        .where("responsable", "==", self.animateur.id)
        .orderBy("nom_groupe")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.groupes.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          self.loading = false;
          this.loadingTable = false;
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
    printFicheFormation(item) {
      let self = this;
      //get membres actifs
      self.SetItemById(item.id);
      self.GetMembresDuGroupe(item.id);

      this.$confirm(
        "Voulez vous vraiment imprimer une  fiche de formation du groupe <strong>" +
          item.nom_groupe +
          "</strong> ?"
      ).then((res) => {
        if (res) {
          console.log("printFicheFormation");
          var objectToSend = {
            membres: this.MembresDuGroupeActifs,
            request: this.request,
            animateur: this.animateur,
          };
          console.log("objectToSend*******", objectToSend);

          this.$router.push({
            name: "detailsGroupe-listeFormationsDeGroupe-print",
            params: objectToSend,
          });
        }
      });
    },

    printFicheDotation(item) {
      let self = this;
      //get membres actifs
      self.SetItemById(item.id);
      self.GetMembresDuGroupe(item.id);
      this.$confirm(
        "Voulez vous vraiment imprimer une  fiche de distribution du groupe <strong>" +
          item.nom_groupe +
          "</strong> ?"
      ).then((res) => {
        if (res) {
          var objectToSend = {
            membres: this.MembresDuGroupeActifs,
            request: this.request,
            animateur: this.animateur,
          };

          this.$router.push({
            name: "detailsGroupe-listeDotationsDeGroupe-print",
            params: objectToSend,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.redPink {
  background-color: darksalmon;
}
</style>
